import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../auth";

export function RequireAdmin() {
  const { loading, configured, sessionToken, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="login-wrap">
        <div className="panel panel-pad">Checking session…</div>
      </div>
    );
  }

  if (!configured) {
    return <Navigate to="/login" replace />;
  }

  if (!sessionToken || !isAdmin) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
